import React from "react";
import { AutoplayProvider } from "../AutoplayContext/AutoplayProvider";
import { VideoAnalyticsProvider } from "../VideoAnalyticsContext";
import { StickyVideoProvider } from "../StickyVideoContext/StickyVideoProvider";
import { AdsElementsRefProvider } from "../AdsElementsRefContext";
import { PromoProvider } from "../PromoContext";
import { OrcaAdsProvider } from "../OrcaAdsContext/OrcaAdsProvider";
import PropTypes from "prop-types";
import { VideoPerformanceProvider } from "../PerformanceContext";
import { HlsProvider } from "../HlsContext/HlsProvider";
import { WpdsProvider } from "../WpdsContext";
import { IntersectionProvider } from "../IntersectionContext/IntersectionProvider";

// This component builds the complete stack of providers for the full player
export const FullFeatureStack = ({
  children,
  config,
  stickyPlayerContext,
  orcaDeps = {}
}) => {
  const { Hls, Popover } = orcaDeps;
  return (
    <HlsProvider {...{ Hls, config }}>
      <WpdsProvider {...{ Popover: Popover }}>
        <AutoplayProvider {...{ config }}>
          <VideoAnalyticsProvider {...{ config }}>
            <IntersectionProvider>
              <StickyVideoProvider {...{ config, stickyPlayerContext }}>
                <AdsElementsRefProvider>
                  <VideoPerformanceProvider {...{ config }}>
                    <PromoProvider>
                      <OrcaAdsProvider {...{ config }}>
                        {children}
                      </OrcaAdsProvider>
                    </PromoProvider>
                  </VideoPerformanceProvider>
                </AdsElementsRefProvider>
              </StickyVideoProvider>
            </IntersectionProvider>
          </VideoAnalyticsProvider>
        </AutoplayProvider>
      </WpdsProvider>
    </HlsProvider>
  );
};

FullFeatureStack.propTypes = {
  children: PropTypes.node.isRequired,
  config: PropTypes.object,
  stickyPlayerContext: PropTypes.object,
  orcaDeps: PropTypes.shape({
    Hls: PropTypes.object,
    Popover: PropTypes.object
  })
};
